import { calculateMargin } from '@common/utils';
import { LtlQuoteViewModel } from '@store/orders/types';

import { QuoteDetailsInsurance } from './types';

export const hasCustomerPricing = (
  quote: Pick<LtlQuoteViewModel, 'customerTotal'>,
  customerId?: number,
) => Boolean(customerId) || (quote.customerTotal ?? 0) > 0;

export const getAgentTotal = (
  quote: Pick<LtlQuoteViewModel, 'carrierTotal'>,
  insurance?: QuoteDetailsInsurance,
) => quote.carrierTotal + (insurance?.premium ?? 0);

export const getCustomerTotal = (
  quote: Pick<LtlQuoteViewModel, 'customerTotal'>,
  insurance?: QuoteDetailsInsurance,
) =>
  (quote.customerTotal ?? 0) +
  (insurance?.premium ?? 0) +
  (insurance?.serviceFee ?? 0);

export const getInsuranceAndFees = (insurance?: QuoteDetailsInsurance) =>
  (insurance?.premium ?? 0) + (insurance?.serviceFee ?? 0);

export const getMarginPercent = (
  quote: Pick<LtlQuoteViewModel, 'carrierTotal' | 'customerTotal'>,
) => calculateMargin(quote.customerTotal ?? 0, quote.carrierTotal);
